export enum GuestVerificationStatus {
    PASSED = '1001',
    CONSIDER = '3001',
    PROCESSING = '4001',
    NO_VERIFICATION = '5001',
    NOT_AVAILABLE = ''
}

export enum GuestVerificationStatusText {
    PASSED = 'PASSED',
    CONSIDER = 'CONSIDER',
    PROCESSING = 'PROCESSING',
    NO_VERIFICATION = 'NOT SCREENED',
    NOT_AVAILABLE = 'NOT AVAILABLE'
}

export enum GuestVerificationCheckType {
    VERIFICATION = 'VERIFICATION',
    BAD_GUEST = 'BAD GUEST',
    BACKGROUND = 'NATIONAL CRIMINAL',
    WATCHLIST = 'WATCHLIST',
    IDENTITY = 'IDENTITY',
    DOCUMENT = 'DOCUMENT',
    SEX_OFFENDER = 'SEX OFFENDER',
    FRAUD = 'FRAUD'
}

export interface Guest {
    id: string;
    reservation_id: number;
    first_name: string;
    last_name: string;
    verified_date: string;
    verification_result_code: GuestVerificationStatus;
    email_sent_date: string;
    identity_result_code: GuestVerificationStatus;
    watch_list_result_code: GuestVerificationStatus;
    sex_offender_result_code: GuestVerificationStatus;
    national_check_result_code: GuestVerificationStatus;
    bad_guest_result_code: GuestVerificationStatus;
}

export interface GuestRow {
    id: number;
    guestName: string;
    verificationDate?: string;
    verificationResult?: string;
    organizationName?: string;
    lastEmailSent?: string;
}